export default __webpack_public_path__ + "static/GESSTwoDWTC-Light-c9a7ecc700f598cf4aa1dd02b3096bdd.ttf";